module.exports = __webpack_public_path__ + "static/pic-vinay@2x.8d4e3d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/leadership/pic-vinay@2x.png
// module id = 855
// module chunks = 137123289437543